import { connect } from 'react-redux'
import SharedEntry from './shared-entry'
import {
  getPresentation,
  getRemovePresentationRequest
} from '../../../../../../../stores/shared-presentations/shared-presentations.selectors'
import { format } from 'date-fns'

const getAccountFullName = account => {
  const anyTeacherType =
    account.teacher_type || account.pending_teacher_type || {}
  const userAccount = anyTeacherType.account
  return !userAccount ? '' : userAccount.full_name
}

const mapStateToProps = (state, { id }) => {
  const sharedPresentation = getPresentation(state, id)
  const removePresentationRequest = getRemovePresentationRequest(state, id)
  const { presentation } = sharedPresentation
  return {
    previewLink: `/shared/${id}`,
    pending: removePresentationRequest.pending,
    title: presentation.title,
    lo: presentation.lesson_overview,
    from: getAccountFullName(presentation.account),
    received: format(sharedPresentation.created_at, 'DD-MM-YYYY'),
    seen: sharedPresentation.seen
  }
}

export default connect(
  mapStateToProps,
  null
)(SharedEntry)
